/**
 * Eager service-worker registration.
 *
 * Runs from main.tsx immediately after render so Lighthouse sees a
 * controlling SW on first navigation (required for PWA category).
 * Skipped inside the editor iframe / preview hosts to keep dev sane.
 */
export function registerServiceWorker(): void {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;

  // Skip inside iframes (Lovable editor preview)
  let inIframe = false;
  try {
    inIframe = window.self !== window.top;
  } catch {
    inIframe = true;
  }
  const host = window.location.hostname;
  const isPreviewHost =
    host.includes("id-preview--") || host.includes("lovableproject.com");
  if (inIframe || isPreviewHost) return;

  try {
    navigator.serviceWorker
      .register("/sw.js")
      .then((registration) => {
        registration.addEventListener("updatefound", () => {
          const sw = registration.installing;
          if (!sw) return;
          sw.addEventListener("statechange", () => {
            if (sw.state === "installed" && navigator.serviceWorker.controller) {
              sw.postMessage({ type: "SKIP_WAITING" });
            }
          });
        });
        let reloaded = false;
        navigator.serviceWorker.addEventListener("controllerchange", () => {
          if (reloaded) return;
          reloaded = true;
          window.location.reload();
        });
        const meta = document.querySelector('meta[name="build-id"]');
        const currentBuildId = meta?.getAttribute("content") ?? "";
        const poll = async () => {
          try {
            const res = await fetch(`/version.json?ts=${Date.now()}`, {
              cache: "no-store",
            });
            if (!res.ok) return;
            const { buildId } = (await res.json()) as { buildId?: string };
            if (buildId && currentBuildId && buildId !== currentBuildId) {
              void registration.update();
            }
          } catch {
            /* offline / 404 — ignore */
          }
        };
        setInterval(poll, 5 * 60 * 1000);
      })
      .catch(() => undefined);
  } catch {
    /* noop */
  }
}